module.exports = __webpack_public_path__ + "static/media/Catalogo-Prestamistas.ad0cdcb1.png";